import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbSizeContext, sizeProviderWrapper } from "abreact/misc/AbSize";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import * as React from "react";
export function AbLabel(props) {
  const contextSize = React.useContext(AbSizeContext);
  const hasChildren = Array.isArray(props.children) ? props.children.length > 0 : props.children != null;
  if (hasChildren) {
    const inner = /*#__PURE__*/React.createElement("label", ReactUtils.componentProps("ab-label", props, [props.size ?? contextSize]), /*#__PURE__*/React.createElement(AbWithTooltip, {
      tooltip: props.tooltip || props.description
    }, /*#__PURE__*/React.createElement("div", {
      className: "ab-label-label"
    }, props.label)), hasChildren && /*#__PURE__*/React.createElement("div", {
      className: "ab-label-value"
    }, props.children));
    return sizeProviderWrapper(inner, props, contextSize);
  } else {
    const inner = /*#__PURE__*/React.createElement(AbWithTooltip, {
      tooltip: props.tooltip || props.description
    }, /*#__PURE__*/React.createElement("label", _extends({}, ReactUtils.componentProps("ab-label", props, [props.size ?? contextSize]), {
      htmlFor: props.for
    }), props.label));
    return sizeProviderWrapper(inner, props, contextSize);
  }
}
//# sourceMappingURL=AbLabel.js.map
